import { action, computed, makeAutoObservable } from "mobx";

import { Entropy } from "../types";

export class EntropyStore {
  private entropy = new Map<string, Entropy>();

  constructor() {
    makeAutoObservable(this);
  }

  @computed
  has(entropy: Entropy): boolean {
    return this.entropy.has(entropy.address);
  }

  @computed
  update(entropy: Entropy): void {
    this.entropy.set(entropy.address, entropy);
  }

  @action
  clear() {
    this.entropy.clear();
  }

  @computed
  getEntropy(): Entropy[] {
    return [...this.entropy.values()];
  }

  @computed
  hasSubmittedEntropy(address: string): boolean {
    const entropy = this.entropy.get(address);
    if (entropy !== undefined) {
      return entropy.has_submitted;
    }

    return false;
  }
}
